import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SourceMoveTo, Breadcrumbs, AvailableEntity, MoveTo } from 'src/app/models';
import { WorkspaceService, BreadcrumbService, ToastService } from 'src/app/services';


@Component({
    selector: 'app-add-edit-destinations',
    templateUrl: './add-edit-destinations.component.html',
    styleUrls: ['./add-edit-destinations.component.scss'],
    standalone: false
})
export class AddEditDestinationsComponent implements OnInit {

    @Input() namesInfo: any
  // This is what to move
  @Input() source: SourceMoveTo;
  // It is used to know if the parent component has been submitted
  didSubmit: boolean;
  @Input('didSubmit') set setDidSubmit(attribute: boolean | '') {
      this.didSubmit = attribute === '' || attribute;
  }

  @Output() sendDestinationToParent: EventEmitter<MoveTo> = new EventEmitter();
  entities: AvailableEntity[] = [];
  dropdown: boolean;
  selected: AvailableEntity;
  path: Breadcrumbs;
  title = 'Select a folder';

  constructor(
    public activeModal: NgbActiveModal,
    private workspaceService: WorkspaceService,
    private breadcrumbService: BreadcrumbService,
    private toastService: ToastService
  ) {
  }

    async ngOnInit() {
      //console.log("OH!!!")
      try {
          if (!this.namesInfo) this.namesInfo = {}
          if (!this.namesInfo?.destination) this.namesInfo.destination = "Destination"
          if (!this.namesInfo?.dropdown_placeholder) this.namesInfo.dropdown_placeholder = 'Select a folder'

          this.title = this.namesInfo.dropdown_placeholder;

          this.entities = (await this.workspaceService.getUserTree(this.source.data.type)).root;
          
          // console.log(this.namesInfo);
          if(!this.source.data.is_restoring){
              if (this.source.data.id && this.source.data.type ) {
                  this.path = (await this.breadcrumbService.getParenthPath(this.source.data.id, this.source.data.type));
          } else if (this.source.data.id_parent && this.source.data.type_parent) {
              this.path = (await this.breadcrumbService.getParenthPath(this.source.data.id_parent, this.source.data.type_parent));
          }
              this.title = this.source.data.name_parent ? this.source.data.name_parent : this.namesInfo.dropdown_placeholder;
          if (this.path) {
              this.initChecked(this.entities);
              }
              // console.log(this.namesInfo)
      }

    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Init the collapsed and selected dropdown items
   * @param array Array of workspaces/projects/folders to view
   */

  initChecked(array: AvailableEntity[]) {
    array.map(entity => {
      entity.collapse = this.path.elementPath.some(path => path.id === entity.id);
      entity.checked = this.source.data.name_parent ? entity.id === this.source.id_parent : false;
      if (entity.children) {
        this.initChecked(entity.children);
      }
    });
  }

  /**
   * Modal submit. For the action of move to send the item to be moved to the parent component
   */
  async onSubmit() {
    let model: MoveTo;

    if (this.selected) {
      model = {
        id_entity: this.source.data.id,
        type: this.source.data.type,
        new_parent: this.selected.id,
        parent_type: this.selected.type
      };
    }
    this.sendDestinationToParent.emit(model);
  }

  /**
   * Check if an element is movable or not
   * @param entity Item to be moved
   */

  isMovable(entity: AvailableEntity) {
    return this.isLocationAvailable(entity) && !this.isMe(entity);
  }

  isLocationAvailable(item: AvailableEntity) {
    switch (this.source.data.type) {
      case 'directory':
      case 'execution':
        return this.isDirecotoryMovable(item);
      default:
        return item.type === 'workspace';
    }
  }

  /**
   * Returns true when the item to be moved is a folder or project
   * @param item Item to check
   */

  isDirecotoryMovable(item: AvailableEntity) {
    return item.type === 'directory' || item.type === 'project';
  }

  /**
   * Check if an item has children inside it
   * @param entity Item to check
   */

  hasChildren(entity: AvailableEntity) {
    return entity.children && entity.children.length;
  }

  /**
   * Check that an item cannot be moved within the item itself
   * @param item Item to check
   */

  isMe(item: AvailableEntity) {
    return item.id === this.source.data.id;
  }

  /**
   * Manages the opening and closing of the dropdown
   */

  handleDropdown() {
    this.dropdown = !this.dropdown;
  }

  /**
   * Check if an entry should be collapsed (opened) or not
   * @param item Item to check
   */

  isOpen(item: AvailableEntity) {
    return this.path ? !!this.path.elementPath.find((path) => path.id === item.id) : false;
  }

  /**
   * Manages the opening and closing of the dropdown items to the selection
   * @param selected Item selected
   */

  handleCollapse(selected: AvailableEntity) {
    selected.collapse = !selected.collapse;
  }

  /**
   * Updates the selection of an item when choosing the item from the select
   * @param array Array of workspaces/projects/folders to view
   */

  updateChecked(array: AvailableEntity[]) {
    array.map(entity => {
      entity.checked = entity.id === this.selected.id;
      if (entity.children) {
        this.updateChecked(entity.children);
      }
    });
  }

  /**
   * Select / deselect the item when clicking in the item checkbox
   * @param item Selected item
   */

  select(item: AvailableEntity) {
    item.checked = !item.checked;
    this.selected = item.checked ? item : null;
    // TODO eliminare l'item selezionato quando viene dececcato
      this.title = item.checked ? this.selected.name : this.namesInfo.dropdown_placeholder;
    if (this.selected) {
      this.updateChecked(this.entities);
      }
      // console.log(item)
    this.onSubmit();
  }

  /**
   * Return the id of a specific item
   * @param items Items list
   */

  getId(items: AvailableEntity[]) {
    if (items.length) {
      return items[0].id;
    } else { return; }
  }

  /**
   * Returns a specific icon based on the item type
   * @param item Item for which to return the icon
   */

  getEntityIcon(item: AvailableEntity) {
    switch (item.type) {
      case 'workspace':
        return 'assets/images/type_workspace.svg';
      case 'project':
        return 'assets/images/type_project.svg';
      case 'directory':
        return 'assets/images/type_directory.svg';
      case 'execution':
        return 'assets/images/type_item.svg';
      default:
        return null;
    }
  }
}
